import { Mapper } from './mapper';

export const NaturezaEstagio = Mapper.from([
  ['O', 'Obrigatório'],
  ['N', 'Não obrigatório'],
]);
